// require('gsap310/src/index.js');
// Charger tous les minified pour exécution
require('gsap310/minified/gsap.min.js');
require('gsap310/minified/DrawSVGPlugin.min.js');
require('gsap310/minified/MorphSVGPlugin.min.js');
require('gsap310/minified/SplitText.min.js');
require('gsap310/minified/ScrollToPlugin.min.js');
require('gsap310/minified/ScrollTrigger.min.js');
require('gsap310/minified/ScrollSmoother.min.js');
require('gsap310/minified/Draggable.min.js');
require('gsap310/minified/InertiaPlugin.min.js');
require('gsap310/minified/CustomEase.min.js');
require('gsap310/minified/MotionPathPlugin.min.js');
require('gsap310/minified/Observer.min.js');
require('gsap310/minified/Flip.min.js');

// Récupérer tous les objets depuis window
var gsap = window.gsap;
var DrawSVGPlugin = window.DrawSVGPlugin;
var MorphSVGPlugin = window.MorphSVGPlugin;
var SplitText = window.SplitText;
var ScrollToPlugin = window.ScrollToPlugin;
var ScrollTrigger = window.ScrollTrigger;
var ScrollSmoother = window.ScrollSmoother;
var Draggable = window.Draggable;
var InertiaPlugin = window.InertiaPlugin;
var CustomEase = window.CustomEase;
var MotionPathPlugin = window.MotionPathPlugin;
var Observer = window.Observer;
var Flip = window.Flip;

// Enregistrer tous les plugins avec gsap
// gsap.registerPlugin(
//   DrawSVGPlugin,
//   MorphSVGPlugin,
//   SplitText,
//   ScrollToPlugin,
//   ScrollTrigger,
//   ScrollSmoother,
//   Draggable,
//   InertiaPlugin,
//   CustomEase,
//   MotionPathPlugin,
//   Observer,
//   Flip
// );

// Test pour vérifier que Flip fonctionne
console.log('GSAP version:', gsap.version);
console.log('Flip disponible ?', typeof Flip); // doit afficher "function"

require('gsap-custom');
